import type { BaseBlockedProduct, BlockedProductIndicators } from './blocked-products';

export type PrioritizedProductListEntry = BaseBlockedProduct & {
  priority: number;
  deliveryForecastDate: string | null;
  meta: {
    prioritizationComment: string | null;
    prioritizedBy: {
      name: string;
      email: string;
    } | null;
  }
}

export const isPrioritizedProductListEntry = (input: any): input is PrioritizedProductListEntry => {
  return typeof input?.priority === 'number';
};

export type CreatePrioritizedProductsPayload = {
  productIds: number[];
  priority: number;
  comment?: string | null;
  deliveryForecastDate: string;
}

export type UpdatePrioritizedProductPayload = Partial<PrioritizedProductListEntry>

export type RevertPrioritizedProductsPayload = {
  productIds: number[];
  comment?: string | null;
}

export type PrioritizedProductIndicators = BlockedProductIndicators;
